import React, { useState } from 'react';

// Tabs/Tab — mirrors react-bootstrap's activeKey/defaultActiveKey/onSelect + <Tab eventKey title>.
export interface TabProps {
  eventKey: string;
  title: React.ReactNode;
  disabled?: boolean;
  children?: React.ReactNode;
}
export const Tab: React.FC<TabProps> = ({ children }) => <>{children}</>;

export interface TabsProps {
  activeKey?: string;
  defaultActiveKey?: string;
  onSelect?: (key: string | null) => void;
  id?: string;
  className?: string;
  children?: React.ReactNode;
}
export const Tabs: React.FC<TabsProps> = ({ activeKey, defaultActiveKey, onSelect, className = '', children }) => {
  const tabs = React.Children.toArray(children).filter(React.isValidElement) as React.ReactElement<TabProps>[];
  const first = tabs[0]?.props.eventKey;
  const [internal, setInternal] = useState<string | undefined>(defaultActiveKey ?? first);
  const current = activeKey !== undefined ? activeKey : internal;
  const select = (k: string) => {
    if (activeKey === undefined) setInternal(k);
    onSelect?.(k);
  };
  const active = tabs.find((t) => t.props.eventKey === current);
  return (
    <div className={className}>
      <div role="tablist" className="tw-flex tw-flex-wrap tw-gap-1 tw-border-b tw-border-line">
        {tabs.map((t) => {
          const isActive = t.props.eventKey === current;
          return (
            <button
              key={t.props.eventKey}
              type="button"
              role="tab"
              disabled={t.props.disabled}
              onClick={() => select(t.props.eventKey)}
              className={`-tw-mb-px tw-border-b-2 tw-px-3 tw-py-2 ${
                isActive
                  ? 'tw-border-primary tw-font-medium tw-text-primary'
                  : 'tw-border-transparent tw-text-content-secondary hover:tw-text-content'
              } disabled:tw-opacity-50`}
            >
              {t.props.title}
            </button>
          );
        })}
      </div>
      <div role="tabpanel" className="tw-pt-3">
        {active?.props.children}
      </div>
    </div>
  );
};

export default Tabs;
